@if(useAsComponent) {
  <div class="f-row f-v-center f-between">
    <div class="price">{{minCtrl.value}}</div>
    <mat-slider [min]="visibleMin" [max]="visibleMax" (change)="applyValues()">
      <input [formControl]="minCtrl" matSliderStartThumb>
      <input [formControl]="maxCtrl" matSliderEndThumb>
    </mat-slider>
    <div class="price">{{maxCtrl.value}}</div>
  </div>

} @else {
  <p>Your budget (per night)</p>
  <div class="f-row f-v-center f-between">
    <div class="price">{{minCtrl.value}}</div>
    <mat-slider [min]="visibleMin" [max]="visibleMax">
      <input [formControl]="minCtrl" matSliderStartThumb>
      <input [formControl]="maxCtrl" matSliderEndThumb>
    </mat-slider>
    <div class="price">{{maxCtrl.value}}</div>
  </div>

  <div class="f-row f-center">
    <button class="btn-default btn-primary" (click)="applyValues()">
      Show
    </button>
  </div>
}
